import React from 'react';
import { WizardReturnType } from './types';

const errorSetup = (close: () => void): WizardReturnType => ({
  title: 'Oops! Something went wrong.',
  content: (
    <div data-test="failure-view-content">
      Project could not be uploaded for some reason. Please try again.
    </div>
  ),
  primaryAction: {
    text: 'Close',
    onClick: close,
    'data-test': 'cancel-button',
    style: { borderRadius: '4px' },
  },
  glyph: 'notification-warning',
  variant: 'danger',
});

export default errorSetup;
